 
import {
    useCallback, useEffect, useState,
} from 'react';
import { BOESlideoutFormValues } from './types';
import { useCalculateBackOfEnvelope } from './hooks/useCalculateBOE';

export const useBOECalculations = (values: BOESlideoutFormValues) => {
    const [calculations, setCalculations] = useState<any>({
        netRentable: 0,
        sfPerUnit: 0,
        grossPotentialRent: 0,
        expenseTotal: 0,
        netOperatingIncome: 0,
        exitValuation: 0,
        calculateLoanAmount: () => 0,
        hardCostsTotal: 0,
        softCostsTotal: 0,
        developerFeeTotal: 0,
        interestReserveTotal: 0,
        loanAmount: 0,
        equityCost: 0,
        returnOnCost: 0,
        returnOnEquity: 0,
        profitReturn: 0,
        totalDevelopmentCosts: 0,
    });

    const { mutate: calculateBOE, data: boeResult } = useCalculateBackOfEnvelope();

    useEffect(() => {
        // Transform empty strings to null to prevent validation errors
        const BOEInputValues = { ...values };
        Object.keys(BOEInputValues).forEach(key => {
            const typedKey = key as keyof BOESlideoutFormValues;
            if (BOEInputValues[typedKey] === '') {
                (BOEInputValues as any)[typedKey] = null;
            }
        });
        calculateBOE(BOEInputValues);
    }, [values, calculateBOE]);

    useEffect(() => {
        if (boeResult) {
            setCalculations({
                netRentable: boeResult.netRentableSf || 0,
                sfPerUnit: boeResult.sfPerUnit || 0,
                grossPotentialRent: boeResult.grossPotentialRent || 0,
                expenseTotal: boeResult.expensesTotal || 0,
                netOperatingIncome: boeResult.netOperatingIncome || 0,
                exitValuation: boeResult.exitValuation || 0,
                calculateLoanAmount: () => boeResult.loanAmount || 0,
                hardCostsTotal: Number(boeResult.hardCostsTotal) || 0,
                softCostsTotal: Number(boeResult.softCostsTotal) || 0,
                developerFeeTotal: boeResult.developerFeeTotal || 0,
                interestReserveTotal: Number(boeResult.interestReserveTotal) || 0,
                loanAmount: boeResult.loanAmount || 0,
                equityCost: boeResult.requiredEquity || 0,
                returnOnCost: boeResult.returnOnCost || 0,
                returnOnEquity: boeResult.returnOnEquity || 0,
                profitReturn: boeResult.profitReturn || 0,
                totalDevelopmentCosts: boeResult.totalDevelopmentCosts || 0,
            });
        }
    }, [boeResult]);

    return calculations;
};

export const useNumberFormatter = () => {
    const formatNumber = useCallback((value: number | null | undefined, placeholder: string = 'TBD'): string => {
        if (value === 0 || value === null || value === undefined || Number.isNaN(value)) {
            return placeholder;
        }
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
    }, []);

    return { formatNumber };
};
